export const customSoftwareContent = {
  tagline: 'Built specifically for your business',
  price: 'Varies by project',
  outcome: 'One system that runs your workflows instead of spreadsheets and scattered apps.',
  bestFor:
    'Best if your team repeats the same manual steps or you need visibility into what happens inside your tools.',
  description:
    'Custom software shaped around how your business actually works. From worker ticketing to audit trails, we build tools your team can rely on every day.',
  highlights: ['Worker ticketing', 'Activity audit trails', 'Fits your workflow'],
  features: [
    'Worker ticketing systems for assignments, requests, and follow ups',
    'Audit centers to track what employees do inside the software',
    'Internal dashboards and real time reporting',
    'Client portals, booking flows, and intake forms',
    'Inventory, scheduling, and resource tracking',
    'Role based access so teams only see what they need',
    'Integrations with tools you already use',
    'Pricing varies by scope. Fill out a consultation and we will quote your build',
  ],
};
